// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".BulkFollowListModal-cls1___385eec15ac70a37cf8a{/*!*/}.BulkFollowListModal-cls2__a6af6334829e400a9c4f{height:24px;width:24px;position:absolute;right:12px;top:12px;padding:0}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "BulkFollowListModal-cls1___385eec15ac70a37cf8a",
	"cls2": "BulkFollowListModal-cls2__a6af6334829e400a9c4f BulkFollowListModal-cls1___385eec15ac70a37cf8a"
};
export default ___CSS_LOADER_EXPORT___;
